import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
let selectedCalendarEventDate = '';
const CALENDAR_SORT_VALUES = ['calendar_event_date_asc', 'calendar_event_date_desc'];
function isCalendarSlug(slug) {
  const calendarTagSlug = String(app.data.calendarEventTagSlug || '').toLocaleLowerCase();
  const currentSlug = String(slug || '').toLocaleLowerCase();
  return currentSlug === 'kalender' || Boolean(calendarTagSlug && calendarTagSlug === currentSlug);
}
function isCalendarTag() {
  return isCalendarSlug(m.route.param('tags'));
}
app.initializers.add('redundans-calendar-event', () => {
  override(Discussion.prototype, 'title', function (original) {
    const originalTitle = original();
    const eventDateRaw = this.attribute('calendarEventDate');
    if (eventDateRaw) {
      try {
        const formattedDate = eventDateRaw.substring(0, 10);
        return "".concat(formattedDate, " - ").concat(originalTitle);
      } catch (e) {}
    }
    return originalTitle;
  });
  override('flarum/forum/components/DiscussionComposer', 'data', function (original) {
    const data = original();
    if (selectedCalendarEventDate) {
      data.calendarEventDate = selectedCalendarEventDate;
    }
    return data;
  });
  override('flarum/forum/components/DiscussionComposer', 'headerItems', function (original) {
    var _this$body$attrs, _composerState$fields;
    const items = original();
    const rawSettings = app.data['calendarEventTags'] || '{}';
    let allowedTags = {};
    try {
      allowedTags = JSON.parse(rawSettings);
    } catch (e) {}
    const composerState = this.composer || ((_this$body$attrs = this.body.attrs) == null ? void 0 : _this$body$attrs.composer);
    const selectedTags = (composerState == null || (_composerState$fields = composerState.fields) == null ? void 0 : _composerState$fields.tags) || [];
    const hasActiveTag = selectedTags.some(tag => {
      const slug = typeof tag.slug === 'function' ? tag.slug() : tag.slug;
      return allowedTags["calendar-event.tags.".concat(slug)] === true;
    });
    if (hasActiveTag) {
      items.add('calendar-event-date-field', m("div", {
        className: "Composer-calendarEventDate"
      }, m("label", null, "Datum: "), m("input", {
        type: "date",
        className: "FormControl",
        value: selectedCalendarEventDate,
        oninput: e => {
          const target = e.target;
          selectedCalendarEventDate = target.value;
        }
      })), 90);
    }
    return items;
  });
  extend(DiscussionListState.prototype, 'sortMap', function (map) {
    if (!isCalendarTag()) {
      return;
    }
    map.calendar_event_date_asc = 'calendar_event_date';
    map.calendar_event_date_desc = '-calendar_event_date';
  });

  // Sidebar tag links carry the current sort along by default (so it isn't
  // lost when only the tag filter changes). Our calendar-only sort values
  // don't make sense for other tags, so strip them from links that don't
  // point at the calendar tag. `initAttrs` is a static method, so it has to
  // be reached via `flarum.reg.onLoad` rather than the string-path form of
  // `extend`, which only patches an extension's prototype methods.
  flarum.reg.onLoad('flarum-tags', 'forum/components/TagLinkButton', TagLinkButton => {
    extend(TagLinkButton, 'initAttrs', function (_result, attrs) {
      var _attrs$params;
      const targetSlug = (_attrs$params = attrs.params) == null ? void 0 : _attrs$params.tags;
      if (attrs.params && CALENDAR_SORT_VALUES.includes(attrs.params.sort) && !isCalendarSlug(targetSlug)) {
        delete attrs.params.sort;
        attrs.route = app.route('tag', attrs.params);
      }
    });
  });
  extend(GlobalSearchState.prototype, 'params', function (params) {
    if (!isCalendarTag() && ['calendar_event_date_asc', 'calendar_event_date_desc'].includes(params.sort)) {
      delete params.sort;
    }
  });
});